import angular from 'angular';
import SetupTwoFactorDialogComponent from './components/setup-two-factor-dialog/setup-two-factor-dialog-component';
import ConfirmTwoFactorDialogComponent from './components/confirm-two-factor-dialog/confirm-two-factor-dialog-component';

export default angular
  .module('two-factor', [])
  .component('setupTwoFactorDialog', new SetupTwoFactorDialogComponent())
  .component('confirmTwoFactorDialog', new ConfirmTwoFactorDialogComponent());



// WEBPACK FOOTER //
// ./src/modules/auth/components/two-factor/two-factor-module.js